module.exports = __webpack_public_path__ + "img/spkf.1dc740ee.png";